import React, { useMemo } from 'react';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';

const Gs1StructuredData = () => {
  const { brand, name, productImages, specifications, gtin, generalCertifications } =
    useContext(ProductContext);

  const markup = useMemo(() => {
    const data: Record<string, any> = {
      '@context': {
        gs1: 'http://gs1.org/voc/',
        xsd: 'http://www.w3.org/2001/XMLSchema#',
        '@vocab': 'http://gs1.org/voc/',
      },
      '@type': 'gs1:Offer',
      itemOffered: {
        '@type': 'gs1:Product',
        productName: [
          {
            '@value': name,
            '@language': 'sv',
          },
        ],
      },
    };

    if (productImages?.length) {
      data.itemOffered.image = {
        referencedFileURL: {
          '@id': productImages[0].url,
        },
      };
    }

    if (brand) {
      data.itemOffered.brand = {
        brandName: [
          {
            '@value': brand.name,
            '@language': 'sv',
          },
        ],
        '@type': 'gs1:Brand',
      };
      if (brand.owner) {
        data.itemOffered.brandOwner = {
          '@id': brand.owner,
        };
      }
    }

    if (specifications?.countryOfOrigin) {
      data.itemOffered.countryOfOriginStatement = [
        {
          '@value': specifications.countryOfOrigin,
          '@language': 'sv',
        },
      ];
    }

    if (gtin) {
      data.itemOffered.gtin = {
        '@id': gtin,
      };
    }

    const svanenCertificationId = '210907033';
    if (generalCertifications?.some((c) => c.id === svanenCertificationId)) {
      data.itemOffered.packagingMarkedLabelAccreditation = [
        {
          '@id': 'gs1:PackagingMarkedLabelAccreditationCode-SVANEN',
        },
      ];
    }

    return JSON.stringify(data);
  }, [brand, name, productImages, specifications, gtin, generalCertifications]);

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: markup }} />;
};

export default Gs1StructuredData;
